import React, { useState } from 'react';
import { FormattedMessage } from '../../localization/index';
import { useRootContext } from '../../providers/RootContext';
import './Menu.scss';

const closeIcon = require('../../assets/imgs/close-icon.svg');
const menuIcon = require('../../assets/imgs/menu-icon.svg');

function Menu() {
  const { getLink, localePortfolioUrl } = useRootContext();
  const [isOpen, setIsOpen] = useState(false);

  const openMenu = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="main-menu">
      <div
        className={`menu-modal ${isOpen ? 'active' : ''}`}
        onClick={closeMenu}
        style={{ display: isOpen ? 'block' : 'none' }}
      ></div>

      <div className="menu-container" onClick={openMenu}>
        <img className="menu-icon" src={menuIcon} alt="Menu button" />
      </div>

      <nav className={`menu ${isOpen ? 'open' : 'closed'}`} id="navMenu">
        <div className="nav-header">
          <button className="nav-close" onClick={closeMenu}>
            <img className="logo" src={closeIcon} alt="Navigation close button" />
          </button>
        </div>
        <ul>
          <li>
            <a className="link nav-link" href={localePortfolioUrl}>
              <FormattedMessage id="home" defaultMessage="Home" />
            </a>
          </li>
          <li>
            <a className="link nav-link" href={getLink('aboutLink')}>
              <FormattedMessage id="aboutUs" defaultMessage="About Us" />
            </a>
          </li>
          <li>
            <a className="link nav-link" href={getLink('contactLink')}>
              <FormattedMessage id="contactUs" defaultMessage="Contact Us" />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Menu;
